import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";


/**
* function for loadProjectTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} loadProjectTimeline loadProjectTimeline function
*/
export const loadProjectTimeline = id => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.loadProjectTimeline(id);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })

    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response.data })
    }
}

/**
* function for createProjectTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} createProjectTimeline createProjectTimeline function
*/
export const createProjectTimelineStrategy = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.createTimelineProjectStrategist(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response.data })
    }
}
/**
* function for createProjectTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} createProjectTimeline createProjectTimeline function
*/
export const createProjectTimelineStage = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.createTimelineProject(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response.data })
    }
}
/**
* function for user register
* @param {*} data form data and history
* @description user register
* @param {function} register register function
*/
export const updateProjectTimeline = (formData, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.updateTimelineProject(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response?.data?.message })
    }
}

/**
* function for Approved ProjectTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} projectTimelineApprovedByApprover ProjectTimeline Approved ProjectTimeline function
*/
export const projectTimelineApprovedByApprover = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.updateProjectTimelineByApprover(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_SUCCESS, payload: data })

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_FAIL, payload: err.response?.data?.message })
    }
}

/**
* function for user update project timeline
* @param {*} data User data 
* @description update user infromation
* @param {function} updateProjectTimeline update project timeline function
*/
export const updateProjectTimelineByOwner = formData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.updateProjectTimelineByOwner(formData)
        toast.success(data.message);
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_SUCCESS, payload: data })
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_FAIL, payload: err.response.data.message })
    }
}
/**
* function for rejected ProjectTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} projectTimelineRejectedByApprover rejected ProjectTimeline function
*/
export const projectTimelineRejectedByApprover = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.rejectProjectTimeline(formData)
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_PROJECT_TIMELINE_FAIL, payload: err.response.data.message })
    }
}

/**
* function for user update Project Timeline
* @param {*} data User data 
* @description update user infromation
* @param {function} sendUpdateProjectTimelineRequestByOwners sendUpdateProjectTimelineRequestByOwners function
*/
export const sendUpdateProjectTimelineRequestByOwners = projectId => async () => {
    try {
        const { data } = await api.requestProjectTimelineEdit(projectId)
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}

/**
* function for user update acceptProjectTimelineUpdateRequestByUser
* @param {*} data User data 
* @description update user infromation
* @param {function} acceptProjectTimelineUpdateRequestByUser acceptProjectTimelineUpdateRequestByUser function
*/
export const acceptProjectTimelineUpdateRequestByUser = (formData, history) => async (dispatch, getState) => {
    try {
        const { data } = await api.acceptProjectTimelineUpdateRequestByUser(formData)
        toast.success(data.message);
        history.push('/')
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}



/**
* function for destroyTimelineStrategist
* @param {*} data User data 
* @description get user infromation
* @param {function} destroyTimelineStrategist destroyTimelineStrategist function
*/
export const destroyTimelineStrategist = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.destroyProjectTimelineStrategist(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response.data })
    }
}
/**
* function for destroyTimelineStage
* @param {*} data User data 
* @description get user infromation
* @param {function} destroyTimelineStage destroyTimelineStage function
*/
export const destroyTimelineStage = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.destroyProjectTimelineStage(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response.data })
    }
}

/**
* function for user update acceptProjectTimelineUpdateRequestByUser
* @param {*} data User data 
* @description update user infromation
* @param {function} acceptProjectTimelineUpdateRequestByUser acceptProjectTimelineUpdateRequestByUser function
*/
export const acceptProjectTimelineInvitationByMember = (formData, history) => async () => {
    try {
        const { data } = await api.apiAcceptProjectTimelineInvitationByMember(formData)
        toast.success(data.message);
        history.push('/')
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}

/**
* function for user update resendInvitation
* @param {*} data User data 
* @description update user infromation
* @param {function} resendInvitation resendInvitation function
*/
export const resendInvitationStrategistByUser = (formData) => async () => {
    try {
        const { data } = await api.apiResendInvitationStrategistByUser(formData)
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}


/**
* function for destroyTimeline
* @param {*} data User data 
* @description get user infromation
* @param {function} destroyTimeline destroyTimeline function
*/
export const timelineAllStages = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_TIMELINE_STAGE_REQUEST })
        const { data } = await api.allTimelineStagesAPI(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.GET_TIMELINE_STAGE_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.GET_TIMELINE_STAGE_FAIL, payload: err.response.data })
    }
}

/**
* function for uploadeProjectTimelineDocument
* @param {*} data User data 
* @description get user infromation
* @param {function} uploadeProjectTimelineDocument uploadeProjectTimelineDocument function
*/
export const uploadeProjectTimelineDocument = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST })
        const { data } = await api.uploadeTimelineDocumentsAPI(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL, payload: err.response.data })
    }
}

/**
* function for user update Document
* @param {*} data User data 
* @description update user infromation
* @param {function} updateDocument updateDocument function
*/
export const updateFileNameByOwner = formData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST })
        const { data } = await api.updateDocumentNameTimelineAPIByOwner(formData)
        toast.success(data.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS, payload: data })
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL, payload: err.response.data.message })
    }
}

/**
* function for project destroyprojectTimelineDocument 
* @param {*} data destroyprojectTimelineDocument  data 
* @description get destroyprojectTimelineDocument  infromation
* @param {function} destroyprojectTimelineDocument destroyprojectTimelineDocument  function
*/
export const destroyProjectTimelineDocument = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST })
        const { data } = await api.deleteTimelineStageDocument(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS, payload: data })
        // window.location.reload();
    } catch (err) {
        toast.error(err.response.data.message)
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL, payload: err.response.data })
    }
}

/**
* function for user documentApprovedByApprover
* @param {*} data form data and history
* @description user documentApprovedByApprover
* @param {function} documentApprovedByApprover documentApprovedByApprover function
*/

export const documentApprovedByApprover = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_REQUEST })
        const { data } = await api.changeTimelineStageStatusByApprover(id);
        toast.success(data.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_SUCCESS, payload: data })
        // window.location.reload();

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.UPLOADE_TIMELINE_STAGE_DOCUMENT_FAIL, payload: err.response?.data?.message })
    }
}

/**
* function for user stageCompleteStatusChangeByOwner
* @param {*} data form data and history
* @description user stageCompleteStatusChangeByOwner
* @param {function} stageCompleteStatusChangeByOwner stageCompleteStatusChangeByOwner function
*/

export const stageCompleteStatusChangeByOwner = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.changeTimelineStageCompeleteByOwner(id);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: data })
        // window.location.reload();

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response?.data?.message })
    }
}
export const stageCompleteStatusByApprover = (formData, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_REQUEST })
        const { data } = await api.rejectApproveStageCompeleteByApprover(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: data })
        history.push('/');

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_TIMELINE_FAIL, payload: err.response?.data?.message })
        history.push('/');
    }
}